import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class RevisionService {
  controller: string = "revision/";
  tipoAceiteController: string = "tipo-aceite/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
  ) { }

  insert(usuario: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear', usuario, this.sesion.headers);
  }

  update(usuario: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'actualizar/' + usuario.id, usuario, this.sesion.headers);
  }

  deactivate(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'desactivar/' + id, this.sesion.headers);
  }

  activate(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "activar/" + id, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "eliminar/" + id, this.sesion.headers);
  }

  index_rol_select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'ver-rol-select', this.sesion.headers);
  }

  view(id: number): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + "view", { id: id, token: this.sesion.token }, this.sesion.headers);
  }

  aceite_index_select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.tipoAceiteController + 'ver-select', this.sesion.headers);
  }

  fecha_estimada(form: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'fecha_estimada', form, this.sesion.headers);
  }

  downloadPdf(element: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `download-pdf/${element.id}`, this.sesion.headersBlob);
  }
}